import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
    import { THGTag } from '@/interfaces/thg/THGTag';
    import { THGTagCategory } from '@/enums/thg/THGTagCategory';

    interface Props {
        value: THGTag;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGTagForm',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', tag: THGTag): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        value: THGTag;
    };

    const colorValue = ref();

    watch(colorValue, () => {
        tag.value.color_rgb = {
            red: colorValue.value.red,
            green: colorValue.value.green,
            blue: colorValue.value.blue,
            alpha: colorValue.value.alpha,
        };
    });

    

    

    const tag = computed<THGTag>({
        get() {
            return props.value;
        },
        set(newVal: THGTag) {
            emit('input', newVal);
        },
    });

    onMounted(() => {
        if (tag.value.color_rgb) {
            // obviously an 'edit', load the tag's color values
            colorValue.value = {
                red: tag.value.color_rgb.red,
                green: tag.value.color_rgb.green,
                blue: tag.value.color_rgb.blue,
                alpha: tag.value.color_rgb.alpha,
            };
        } else {
            // obviously a 'new', set default INSTADRIVE colors
            colorValue.value = {
                red: 22,
                green: 186,
                blue: 231,
                alpha: 0,
            };
        }
    });

return { __sfc: true,colorValue, props, emit, tag, THGTagCategory }
}

})